import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Scrollspy, { Easing } from 'vue2-scrollspy'


Vue.use(Scrollspy, {
  easing: Easing.Cubic.In
})

import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
Vue.use(VuetifyDialog, {
  context: {
    vuetify,
  },
})

import 'sweetalert2/dist/sweetalert2.min.css';
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import Sticky from 'vue-sticky-directive'
Vue.use(Sticky)

import LottiePlayer from 'lottie-player-vue'
Vue.use(LottiePlayer)

import FlagIcon from 'vue-flag-icon'
Vue.use(FlagIcon);

import VuePageTransition from 'vue-page-transition'
Vue.use(VuePageTransition)

import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
Vue.use(TiptapVuetifyPlugin, { vuetify, iconsGroup: 'mdi' })

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

Vue.config.productionTip = false


import '@aws-amplify/ui-vue'
import Amplify from 'aws-amplify'

import CONFIG from '@/config'

Amplify.configure({
	Auth: CONFIG.Auth,
	Storage: CONFIG.Storage
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
